import { useMemo } from 'react';
import { StringParam, withDefault } from 'use-query-params';
import { usePageParams } from '../../../hooks/usePageParams';

export type SettingsPageParams = {
  customerID: string;
};

// Settings page optionally handles customerID for BlockSettings functionality
// Navigation TO settings is clean, but Settings can read context if provided
export function useSettingsPageParams() {
  const config = useMemo(
    () => ({
      customerID: withDefault(StringParam, ''),
    }),
    []
  );

  return usePageParams<SettingsPageParams>(config);
}
